require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./d-2-c-summit.json") })
        }
      }, "path---d-2-c-summit");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---d-2-c-summit!./.cache/json/d-2-c-summit.json
// module id = 1053
// module chunks = 231608221292675